module.exports = function getResource(label, vars = []) {
    let resources = {
        sameDayDelivery: 'Same-Day Delivery',
        deliveringTo: 'Delivering to ',
        yourLocation: 'your location'
    };
    return resources[label];
};
